<template>
    <div>
        <div class="margin-right-15 margin-top-15" style="text-align: right">
            <vButton
                v-if="
                    alltype != 'query' &&
                    alltype != 'priceA' &&
                    alltype != 'improve'
                "
                theme="primary"
                @click="addItem"
                >{{
                    $t("global.common.add_detail", { defaultValue: "添加详细" })
                }}</vButton
            >
        </div>
        <vTable
            class="margin-left-10 margin-right-10 margin-top-15"
            :columns="columns"
            :data="formList"
            size="small"
            ref="table"
            border
        ></vTable>
    </div>
</template>

<script>
import mixin from "./mixin";

export default {
    mixins: [mixin],
    props: ["alltype", "productformdata"],
    components: {},
    data() {
        return {
            formData: {},
            formList: [],
            visible: false,
        };
    },
    created() {},
    computed: {
        columns() {
            let _this = this;
            const isImprove = this.alltype === "improve";
            const data = [
                {
                    key: "releaseProductName",
                    has: isImprove,
                    renderHeader: (h) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "品名-中文"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h("Input", {
                                props: {
                                    value: row.releaseProductName,
                                    readonly: true,
                                },
                                on: {
                                    input: (event) => {
                                        row.releaseProductName = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.releaseProductName}</div>;
                        }
                    },
                },
                {
                    key: "releaseProductEn",
                    has: isImprove,
                    renderHeader: (h) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "品名-英文"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h("Input", {
                                props: {
                                    value: row.releaseProductEn,
                                    readonly: true,
                                },
                                on: {
                                    input: (event) => {
                                        row.releaseProductEn = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.releaseProductEn}</div>;
                        }
                    },
                },
                {
                    key: "erpSku",
                    has: isImprove,
                    renderHeader: (h) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "ERPSKU"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h("vInput", {
                                props: {
                                    value: row.erpSku,
                                    suffix: "search",
                                    readonly: true,
                                },
                                on: {
                                    "on-icon-click": () => {
                                        _this.handleSkuErp(row, index);
                                    },
                                },
                            });
                        } else {
                            return <div>{row.erpSku}</div>;
                        }
                    },
                },
                {
                    key: "releaseProductName",
                    has: !isImprove,
                    renderHeader: (h) => {
                        return h("div", [h("strong", "品名-中文")]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h("Input", {
                                props: {
                                    value: row.releaseProductName,
                                },
                                on: {
                                    input: (event) => {
                                        row.releaseProductName = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.releaseProductName}</div>;
                        }
                    },
                },
                {
                    key: "releaseProductEn",
                    has: !isImprove,
                    renderHeader: (h) => {
                        return h("div", [h("strong", "品名-英文")]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h("Input", {
                                props: {
                                    value: row.releaseProductEn,
                                },
                                on: {
                                    input: (event) => {
                                        row.releaseProductEn = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.releaseProductEn}</div>;
                        }
                    },
                },
                {
                    key: "erpSku",
                    has: !isImprove,
                    renderHeader: (h) => {
                        return h("div", [h("strong", "ERPSKU")]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit) {
                            return h("Input", {
                                props: {
                                    value: row.erpSku,
                                },
                                on: {
                                    input: (event) => {
                                        row.erpSku = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.erpSku}</div>;
                        }
                    },
                },
                {
                    key: "innerBoxLength",
                    renderHeader: (h) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "内箱长(mm)"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit && _this.alltype != "improve") {
                            return h("vInputNumber", {
                                props: {
                                    value: row.innerBoxLength,
                                },
                                on: {
                                    input: (event) => {
                                        row.innerBoxLength = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.innerBoxLength}</div>;
                        }
                    },
                },
                {
                    key: "innerBoxWidth",
                    renderHeader: (h) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "内箱宽(mm)"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit && _this.alltype != "improve") {
                            return h("vInputNumber", {
                                props: {
                                    value: row.innerBoxWidth,
                                },
                                on: {
                                    input: (event) => {
                                        row.innerBoxWidth = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.innerBoxWidth}</div>;
                        }
                    },
                },
                {
                    key: "innerBoxHeight",
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "内箱高(mm)"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit && _this.alltype != "improve") {
                            return h("Input", {
                                props: {
                                    value: row.innerBoxHeight,
                                },
                                on: {
                                    input: (event) => {
                                        row.innerBoxHeight = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.innerBoxHeight}</div>;
                        }
                    },
                },
                {
                    key: "outerBoxLength",
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "外箱长(mm)"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit && _this.alltype != "improve") {
                            return h("Input", {
                                props: {
                                    value: row.outerBoxLength,
                                },
                                on: {
                                    input: (event) => {
                                        row.outerBoxLength = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.outerBoxLength}</div>;
                        }
                    },
                },
                {
                    key: "outerBoxWidth",
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "外箱宽(mm)"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit && _this.alltype != "improve") {
                            return h("Input", {
                                props: {
                                    value: row.outerBoxWidth,
                                },
                                on: {
                                    input: (event) => {
                                        row.outerBoxWidth = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.outerBoxWidth}</div>;
                        }
                    },
                },
                {
                    key: "outerBoxHeight",
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "外箱高(mm)"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit && _this.alltype != "improve") {
                            return h("Input", {
                                props: {
                                    value: row.outerBoxHeight,
                                },
                                on: {
                                    input: (event) => {
                                        row.outerBoxHeight = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.outerBoxHeight}</div>;
                        }
                    },
                },
                {
                    key: "pieceWeight",
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "单件重量kg"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit && _this.alltype != "improve") {
                            return h("Input", {
                                props: {
                                    value: row.pieceWeight,
                                },
                                on: {
                                    input: (event) => {
                                        row.pieceWeight = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.pieceWeight}</div>;
                        }
                    },
                },
                {
                    key: "boxWeight",
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h("strong", "整箱毛重kg"),
                        ]);
                    },
                    render(h, { row, index }) {
                        if (row.$Edit && _this.alltype != "improve") {
                            return h("Input", {
                                props: {
                                    value: row.boxWeight,
                                },
                                on: {
                                    input: (event) => {
                                        row.boxWeight = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.boxWeight}</div>;
                        }
                    },
                },
                {
                    title: this.$t("global.common.operation", {
                        defaultValue: "操作",
                    }),
                    width:
                        this.alltype != "query" && this.alltype != "priceA"
                            ? this.alltype == "improve"
                                ? 70
                                : 140
                            : 0,
                    render(h, { row, index }) {
                        if (_this.alltype == "improve") {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                        },
                                        style: {
                                            marginRight: "5px",
                                        },
                                        on: {
                                            click: () => {
                                                _this.changeEdit(row);
                                            },
                                        },
                                    },
                                    this.$t("global.common.operation_edit", {
                                        defaultValue: "编辑",
                                    })
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                        },
                                        style: {
                                            marginRight: "5px",
                                        },
                                        on: {
                                            click: () => {
                                                _this.changeEdit(row);
                                            },
                                        },
                                    },
                                    this.$t("global.common.operation_edit", {
                                        defaultValue: "编辑",
                                    })
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                _this.comremove(index);
                                            },
                                        },
                                    },
                                    this.$t("global.common.delete", {
                                        defaultValue: "删除",
                                    })
                                ),
                            ]);
                        }
                    },
                },
            ];
            return data.filter((item) => {
                const has = item.has;
                return !!(has === undefined || has);
            });
        },
    },
    methods: {
        handledata() {
            this.formList = this.productformdata.detailEntities || [];
            if (this.alltype == "query" || this.alltype == "priceA") return;
        },
        changeEdit(row) {
            this.$set(row, "$Edit", true);
        },
        comremove(index) {
            this.formList.splice(index, 1);
        },
        //查询ERPSKU - 保持不变
        handleSkuErp(row, index) {
            this.$emit("open-erp-modal", {
                row: row,
                index: index,
            });
        },
        // 处理ERP选择结果 - 自动填入并验证数据一致性
        handleErpSelection(selectedData, originalRow, originalIndex) {
            if (!originalRow || originalIndex === undefined) return;

            // 验证数据一致性
            const errorField = this.validateDimensionConsistency(
                selectedData,
                originalRow
            );

            if (errorField) {
                this.$Message.error(`${errorField}数据不一致`);
                return;
            }

            // 自动填入三个主要字段
            originalRow.erpSku = selectedData.sku || "";
            originalRow.releaseProductName = selectedData.name || "";
            originalRow.releaseProductEn = selectedData.nameEn || "";

            this.$set(this.formList, originalIndex, originalRow);
            this.$Message.success("数据导入成功");
        },

        // 验证尺寸和重量数据一致性
        validateDimensionConsistency(selectedData, originalRow) {
            // 单位换算系数
            const CM_TO_MM = 10; // 1 cm = 10 mm
            const G_TO_KG = 0.001; // 1 g = 0.001 kg

            const fieldMap = {
                内箱长: {
                    existing: originalRow.innerBoxLength,
                    erp: selectedData.length
                        ? selectedData.length * CM_TO_MM
                        : null,
                },
                内箱宽: {
                    existing: originalRow.innerBoxWidth,
                    erp: selectedData.width
                        ? selectedData.width * CM_TO_MM
                        : null,
                },
                内箱高: {
                    existing: originalRow.innerBoxHeight,
                    erp: selectedData.height
                        ? selectedData.height * CM_TO_MM
                        : null,
                },
                外箱长: {
                    existing: originalRow.outerBoxLength,
                    erp: selectedData.packedLength
                        ? selectedData.packedLength * CM_TO_MM
                        : null,
                },
                外箱宽: {
                    existing: originalRow.outerBoxWidth,
                    erp: selectedData.packedWidth
                        ? selectedData.packedWidth * CM_TO_MM
                        : null,
                },
                外箱高: {
                    existing: originalRow.outerBoxHeight,
                    erp: selectedData.packedHeight
                        ? selectedData.packedHeight * CM_TO_MM
                        : null,
                },
                单件重量: {
                    existing: originalRow.pieceWeight,
                    erp: selectedData.weight
                        ? selectedData.weight * G_TO_KG
                        : null,
                },
                整箱毛重: {
                    existing: originalRow.boxWeight,
                    erp: selectedData.packedWeight
                        ? selectedData.packedWeight * G_TO_KG
                        : null,
                },
            };

            for (const [fieldName, data] of Object.entries(fieldMap)) {
                if (data.existing && data.erp) {
                    // 考虑小数精度，保留4位小数进行比较
                    const existingValue = parseFloat(data.existing).toFixed(4);
                    const erpValue = parseFloat(data.erp).toFixed(4);

                    if (existingValue !== erpValue) {
                        return fieldName;
                    }
                }
            }

            return null;
        },
        addItem(data) {
            let obj = {
                releaseProductName: data.releaseProductName,
                releaseProductEn: data.releaseProductEn,
                erpSku: data.erpSku,
                innerBoxLength: data.innerBoxLength,
                innerBoxWidth: data.innerBoxWidth,
                innerBoxHeight: data.innerBoxHeight,
                outerBoxLength: data.outerBoxLength,
                outerBoxWidth: data.outerBoxWidth,
                outerBoxHeight: data.outerBoxHeight,
                pieceWeight: data.pieceWeight,
                boxWeight: data.boxWeight,
                $Edit: true,
            };
            this.formList.push(obj);
            this.visible = false;
        },
        async validate() {
            const bool = await this.$refs["clearform"].validate();
            if (!bool) {
                this.$VMessage.warning(
                    this.$t("global.common.fill_required", {
                        defaultValue: "请填写必填项",
                    })
                );
            }
            return bool;
        },
    },
    watch: {
        productformdata() {
            this.handledata();
        },
    },
};
</script>
